import { useMutation, useQueryClient } from 'react-query';

import { apiClient } from 'src/services/api/client';
import { queryKeys } from 'src/services/api/constants';
import { touringHoursPath } from 'src/services/api/touring-hours/paths';
import type {
    ISetTouringHoursRequest,
    ITouringHours,
    ITouringHoursResponse,
} from 'src/services/api/touring-hours/types';

export function useSetTouringHours(propertyId?: number | null) {
    const queryClient = useQueryClient();

    return useMutation<ITouringHours, Error, ISetTouringHoursRequest>(
        async (payload) => {
            const res = await apiClient(touringHoursPath(propertyId as number), {
                method: 'put',
                json: payload,
            }).json<ITouringHoursResponse>();
            return res.touring_hours;
        },
        {
            onSuccess: () => {
                queryClient.invalidateQueries(queryKeys.touringHours);
                queryClient.invalidateQueries(queryKeys.properties);
            },
        }
    );
}
